import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { AccessState, CoreFeatureModule } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { UserAuthenticationStrategiesComponent } from './authentication-strategies.component';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/card";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../core/frontend-shared/src/lib/feature/router-link-resolver/feature-router-link-resolver.pipe";
const _c0 = ["*"];
function UserAuthenticationComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "user-authentication-strategies");
  }
}
function UserAuthenticationComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2, "Du bist eingeloggt.");
    i0.ɵɵelement(3, "br")(4, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 3);
    i0.ɵɵpipe(6, "resolveRouterLink");
    i0.ɵɵtext(7, "Logout");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 1, "logout"));
  }
}
export let UserAuthenticationComponent = /*#__PURE__*/(() => {
  class UserAuthenticationComponent {
    constructor() {
      this.resetPasswordEnabled = true;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
    }
    static {
      this.ɵfac = function UserAuthenticationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAuthenticationComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UserAuthenticationComponent,
        selectors: [["user-authentication"]],
        inputs: {
          resetPasswordEnabled: "resetPasswordEnabled"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 6,
        consts: [["size", "small"], [1, "content"], [1, "box"], ["uiButton", "", 1, "ui-button-grey", 3, "routerLink"]],
        template: function UserAuthenticationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ui-content-centered")(1, "ui-card", 0)(2, "div", 1);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(4, UserAuthenticationComponent_Conditional_4_Template, 1, 0, "user-authentication-strategies");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵconditionalCreate(6, UserAuthenticationComponent_Conditional_6_Template, 8, 3, "div", 2);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(!i0.ɵɵpipeBind1(5, 2, ctx.loggedIn$) ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(i0.ɵɵpipeBind1(7, 4, ctx.loggedIn$) ? 6 : -1);
          }
        },
        dependencies: [CommonModule, CoreFeatureModule, UiContentCenteredComponent, i1.UiCardComponent, UiButtonComponent, RouterLink, UserAuthenticationStrategiesComponent, i2.AsyncPipe, i3.RouterLinkResolverPipe],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center}.links[_ngcontent-%COMP%]{text-align:center;margin-top:10px}.links[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{margin-top:5px}.content[_ngcontent-%COMP%]:not(:empty){margin-bottom:10px;text-align:center}.content[_ngcontent-%COMP%]:not(:empty)     app-logo{margin:0 auto}"]
      });
    }
  }
  return UserAuthenticationComponent;
})();